import React from 'react'
import DatePickerCustom from '../../DatePickerCustom'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Filter } from '../../../assets/svg/filter.svg'
import TargetGroupModal from '../../modals/TargetGroupModal'
import { useState } from 'react'
import { translateTargetText } from '../../../utils/util'
import ClassYearFilter from './ClassYearFilter'
import { mode } from 'd3'
import { Icon } from './PulseCategoryList'

function PulseFilterContainer({ startDate, endDate, handleDateSelect, updateAnalytics, handleLastMonth, mode, setMode, targetGroup, setTargetGroup, onDownload, downloading = false, downloadDisabled = false }) {
    const { t, locale } = useTranslation()
    const [showTargetModal, setShowTargetModal] = useState(false)

    const closeTargetModal = () => {
        setShowTargetModal(false)
    }
    const setReturnTarget = (item) => {
        const { name, selection, target, type } = item
        const targetOptions = {
            selection: selection,
            type: type,
        }
        setTargetGroup({
            text: name || 'My students',
            target: target?.map((e) => e?.id),
            unfilteredTarget: target,
            targetOptions: targetOptions,
        })
    }
    return (
        <div className="bg-white rounded-[10px] mt-[22px] py-[22px] px-7 flex flex-row items-center justify-between gap-4 shadow-containerWhite ">
            <div className="flex flex-row items-center gap-[14px]">
                <p className="text-mudPurple font-medium text-[14px] leading-5">{t('chooseDataRange')}:</p>
                <DatePickerCustom startDate={startDate} endDate={endDate} handleDateSelect={handleDateSelect} handleOkButton={updateAnalytics} handleLastMonth={handleLastMonth} />
            </div>
            <div className="flex flex-row items-center gap-[14px]">
                {/* <ClassYearFilter mode={mode} setMode={setMode} /> */}
                <div className="analytics-target-button" style={{ height: 40, marginLeft: 0 }} onClick={() => setShowTargetModal(true)}>
                    <Filter fill="#413F5E" />
                    <p className="text-center">{translateTargetText(targetGroup.text)}</p>
                </div>
                {onDownload && (
                    <div
                        className="analytics-target-button"
                        style={{ height: 40, marginLeft: 0, opacity: downloadDisabled ? 0.5 : 1, cursor: downloadDisabled ? 'default' : 'pointer', pointerEvents: downloadDisabled ? 'none' : 'auto' }}
                        onClick={() => !downloadDisabled && onDownload()}
                    >
                        <Icon name="download" size={16} color="#413F5E" stroke={2} />
                        <p className="text-center">{downloading ? t('Downloading...') : t('Download')}</p>
                    </div>
                )}
            </div>
            <TargetGroupModal showTarget={showTargetModal} closeTarget={closeTargetModal} setReturnTarget={setReturnTarget} />
        </div>
    )
}

export default PulseFilterContainer
